import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { GraficoPizza } from '@monorepo-web/components-library';
import { getLayouts } from './layouts';
import BaseGrafico from '../../library/GraficoBase';
export default function GraficoAlocacao(props) {
    const { GraphComponent = GraficoPizza, titulo = 'Alocação por Classe', data, height = 550, moneyPrefix, layout = 'default', onClickHandle, FormatTypeParam, theme, alignTitleCenter = true } = props;
    const config = getLayouts(theme)[layout];
    return (_jsx(_Fragment, { children: _jsx(BaseGrafico, { titulo: titulo, alignTitleCenter: alignTitleCenter, graphElement: _jsx(GraphComponent, Object.assign({ data: data, height: height, onClickHandle: onClickHandle, moneyPrefix: moneyPrefix, FormatTypeParam: FormatTypeParam }, config)) }) }));
}
